module.exports = __webpack_public_path__ + "images/etiquete_bio-ebbbd758f1938327815f3db2de027243.svg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/etiquete_bio.svg
// module id = 51
// module chunks = 0 1